import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
      <p className='footer-copyright'>© Copyright 2024 Amsterdam Museum</p>
    </div>
  );
}

export default Footer;